type BuildPromotionalUrlParams = {
	isEngagement: boolean;
	email: string;
	source: "modal" | "banner" | "icon";
	promotionId: string;
};

export const buildPromotionalUrl = ({
	isEngagement,
	email,
	source,
	promotionId,
}: BuildPromotionalUrlParams): string => {
	const baseUrl = isEngagement
		? "https://www.performyard.com/performyard-engage-ai"
		: "https://www.performyard.com/performyard-ai";

	const params = new URLSearchParams({ email, source, promotionId });
	return `${baseUrl}?${params.toString()}`;
};
